import { useNavigate } from 'react-router';
import './seeall.scss';
import { urls } from '../model';

export const SeeAll = () => {
	const navigate = useNavigate();
	const handleNavigateToSeeAll = () => {
		navigate(urls.productsExpo);
		window.scrollTo(0, 0);
	};
	return (
		<div className='seeaAllMainContainer'>
			<div className='seeAllContainer'>
				<p onClick={handleNavigateToSeeAll} className='seeall'>
					See all products at Expo West
					<i className='ri-arrow-right-line'></i>
				</p>
			</div>
		</div>
	);
};
